import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type Language = "pt" | "en"

interface LocalizationState {
	currentLanguage: Language
}

const initialState: LocalizationState = {
	currentLanguage: "pt"
}

const localizationSlice = createSlice({
	name: "localization",
	initialState,
	reducers: {
		setLanguage: (state, action: PayloadAction<Language>) => {
			state.currentLanguage = action.payload
		}
	}
})

export const { setLanguage } = localizationSlice.actions

export default localizationSlice.reducer
